/* @flow */
import React from "react";

import { Well } from "react-bootstrap";
import { generateUuid } from "shared/src/utils/util";
import { trackContentView, trackOpenContentResult } from "../../../utils/ContentTrackingUtil";
import { SearchResultItem } from "../../../datatypes/ContentSearch";
import { FormattedMessage } from "react-intl";

type Props = {
    item: SearchResultItem;
};

class ContentSearchResultItem extends React.Component<Props> {
    eventId: string;

    constructor(props: Props) {
        super(props);
        this.eventId = generateUuid();
        const item = props.item;
        trackContentView(this.eventId, item.targetUrl, item.title, item.imageUrl, item.description);
    }

    trackContentClick = () => {
        const item = this.props.item;
        trackOpenContentResult(this.eventId, item.targetUrl, item.title, item.imageUrl, item.description);
    };

    render() {
        const item = this.props.item;
        return (
            <Well className="mfcss_flexbox-post">
                <div className="mfcss_flexbox-post-content">
                    {item.imageUrl && <img src={item.imageUrl} alt={item.title} className="img-responsive" />}
                    {item.title && <h4>{item.title}</h4>}
                    {item.description && <p>{item.description}</p>}
                </div>
                <div className="mfcss_flexbox-post-footer">
                    {item.targetUrl && (
                        <a href={item.targetUrl} onClick={this.trackContentClick}>
                            <FormattedMessage id="EX_CONTENT_SEARCH_READ_MORE" />
                        </a>
                    )}
                </div>
            </Well>
        );
    }
}

export default ContentSearchResultItem;
